import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import { getImgURL } from '@shared-submodule/utils'

function ChampionsTeamsMweb({ team, isMobile = false }) {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center w-100 mt-4">
        <h2 className={`${styles.title} mt-2`}>Teams</h2>
      </div>

      <div className={`${styles.mainContainer}`}>
        {team?.map((a, i) => {
          if (a?.oSeo?.sSlug && !isMobile) {
            return (
              <CustomLink key={i} href={`/${a?.oSeo?.sSlug}`} className="cursor-pointer">
                <a>
                <div className="flex flex-column">
                  <div className={styles.teamContainer}>
                    <MyImage src={getImgURL(a?.oImg?.sUrl)} height={150} width={150} />
                  </div>
                  <h6 className={styles.teamName}>{a?.sTitle}</h6>
                </div>
                </a>
              </CustomLink>
            )
          } else {
            return (
              <div className="flex flex-column" key={i}>
                <div className={styles.teamContainer}>
                  <MyImage src={getImgURL(a?.oImg?.sUrl)} height={150} width={150} />
                </div>
                <h6 className={styles.teamName}>{a?.sTitle}</h6>
              </div>
            )
          }
        })}
      </div>
    </>
  )
}

ChampionsTeamsMweb.propTypes = {
  team: PropTypes.array,
  isMobile: PropTypes.bool
}

export default ChampionsTeamsMweb
